import React from 'react';
import {t} from '@lingui/core/macro';

import MainModal from 'shared/ui/Modal/MainModal';
import ProblemMonitor from 'shared/ui/icons/ProblemMonitor';
import SuccessfulMonitor from 'shared/ui/icons/SuccessfulMonitor';
import DomainIncident from 'features/domain/ui/DomainIncident/DomainIncident/DomainIncident';
import IDomainIncident from 'features/domain/model/DomainIncident/IDomainIncident';
import {getFormattedDate, IDateOptions} from 'shared/lib/datetime';
import {isTranslate} from 'shared/lib/lang';

import styles from './DomainIncidentModal.module.scss';

interface IDomainIncidentModalProps {
    open: boolean,
    item: IDomainIncident,
    handleClose: () => void,
    tzString?: string | null,
}

const DomainIncidentModal: React.FC<IDomainIncidentModalProps> = ({open, item, handleClose, tzString}) => {
    if (!item) return null;

    const domainName = item.domainHumanReadable || item.domain || t`Неизвестный домен`;
    const problemStatus = !item.resolved;

    const dateOptions: IDateOptions = {
        format: !isTranslate() ? 'DD.MM.YYYY, в HH:mm' : 'YYYY-MM-DD, in HH:mm',
        tzString,
    };

    const dialogClassName = problemStatus
        ? (isTranslate() ? styles.enBackgroundModal : styles.backgroundModal)
        : undefined;

    return (
        <MainModal
            header={
                <div>
                    <div className={styles.contentHeader}>
                        {t`Инцидент домена`}
                        <span className={styles.title}> - {domainName}</span>
                    </div>
                    <div className={styles.contentInfo}>
                        <div className={styles.monitorNameMobile}>
                            <span>{t`Домен`}</span>
                            <span>{domainName}</span>
                        </div>
                        <div className={styles.itemInfo}>
                            <span className={styles.title}>{t`Статус`}</span>
                            <div className={styles.containerStatus}>
                                {problemStatus ? <ProblemMonitor /> : <SuccessfulMonitor />}
                                <span className={problemStatus ? styles.problem : styles.normal}>
                                    {problemStatus ? t`Не решён` : t`Решён`}
                                </span>
                            </div>
                        </div>
                        <div className={styles.itemInfo}>
                            <span className={styles.title}>{t`Дата возникновения`}</span>
                            <div className={styles.data}>
                                {getFormattedDate(item.created_at, dateOptions)}
                            </div>
                        </div>
                        <div className={styles.itemInfo}>
                            <span className={styles.title}>{t`Дата решения`}</span>
                            <div className={styles.data}>
                                {getFormattedDate(item.resolved_at, dateOptions)}
                            </div>
                        </div>
                        <div className={styles.itemInfo}>
                            <span className={styles.title}>{t`Решить до`}</span>
                            <div className={styles.data}>
                                {getFormattedDate(item.expire_at, dateOptions)}
                            </div>
                        </div>
                    </div>
                </div>
            }
            open={open}
            handleClose={handleClose}
            size="md"
            dialogClassName={dialogClassName}
        >
            <DomainIncident item={item} />
        </MainModal>
    );
};

export default DomainIncidentModal;
